import React from 'react';

function InternshipProgram() {
  const positions = [
    {
      title: 'Software Engineering Intern',
      department: 'Engineering',
      location: 'Worldwide (Remote)',
      duration: '3-6 months',
      requirements: [
        'Currently pursuing a Bachelor\'s degree in Computer Science or related field',
        'Strong programming fundamentals in JavaScript/TypeScript',
        'Experience with React and modern web technologies',
        'Excellent problem-solving skills'
      ]
    },
    {
      title: 'Marketing Intern',
      department: 'Marketing',
      location: 'Worldwide (Remote)',
      duration: '3-6 months',
      requirements: [
        'Currently pursuing a degree in Marketing, Business, or related field',
        'Strong understanding of digital marketing principles',
        'Experience with social media platforms',
        'Excellent written and verbal communication skills'
      ]
    },
    {
      title: 'Business Development Intern',
      department: 'Sales',
      location: 'Worldwide (Remote)',
      duration: '3-6 months',
      requirements: [
        'Currently pursuing a degree in Business, Economics, or related field',
        'Strong analytical and research skills',
        'Excellent communication and presentation abilities',
        'Interest in e-commerce and MENAP markets'
      ]
    }
  ];

  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-24 lg:px-8">
        {/* Hero Section - updated styling */}
        <div className="text-center mb-16">
          <h2 className="text-base font-semibold text-[#0049ac] tracking-wide uppercase">Join Our Team</h2>
          <p className="mt-1 text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl">
            Internship Program
          </p>
          <p className="max-w-xl mt-5 mx-auto text-xl text-gray-500">
            Launch your career with SellAbroad and help transform e-commerce in the MENAP region.
          </p>
        </div>

        {/* Program Overview - updated styling */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-8">Program Overview</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="relative bg-gray-100 p-6 rounded-lg shadow-sm hover:shadow-md transition-all transform hover:scale-105">
              <div className="absolute -top-4 left-6">
                <div className="rounded-lg bg-[#0049ac] p-3 inline-block">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
              </div>
              <div className="flex-1">
                <h4 className="mt-8 text-xl font-semibold text-gray-900">Duration</h4>
                <p className="mt-4 text-gray-600 leading-relaxed">3-6 months, flexible hours</p>
              </div>
            </div>
            <div className="relative bg-gray-100 p-6 rounded-lg shadow-sm hover:shadow-md transition-all transform hover:scale-105">
              <div className="absolute -top-4 left-6">
                <div className="rounded-lg bg-[#0049ac] p-3 inline-block">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064" />
                  </svg>
                </div>
              </div>
              <div className="flex-1">
                <h4 className="mt-8 text-xl font-semibold text-gray-900">Location</h4>
                <p className="mt-4 text-gray-600 leading-relaxed">Worldwide (Remote)</p>
              </div>
            </div>
            <div className="relative bg-gray-100 p-6 rounded-lg shadow-sm hover:shadow-md transition-all transform hover:scale-105">
              <div className="absolute -top-4 left-6">
                <div className="rounded-lg bg-[#0049ac] p-3 inline-block">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
              </div>
              <div className="flex-1">
                <h4 className="mt-8 text-xl font-semibold text-gray-900">Benefits</h4>
                <p className="mt-4 text-gray-600 leading-relaxed">Real Work Experience + Mentorship + Full-time opportunity</p>
              </div>
            </div>
          </div>
        </div>

        {/* Open Positions - updated styling */}
        <div>
          <h3 className="text-2xl font-bold text-gray-900 mb-8">Open Positions</h3>
          <div className="space-y-6">
            {positions.map((position, index) => (
              <div 
                key={index} 
                className="bg-gray-100 border border-gray-200 rounded-lg p-6 hover:shadow-md transition-all"
              >
                <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                  <div>
                    <h4 className="text-xl font-semibold text-gray-900">{position.title}</h4>
                    <p className="text-gray-500 mt-1">{position.department} • {position.location}</p>
                  </div>
                  <div className="mt-4 md:mt-0">
                    <button
                      onClick={() => window.location.href = `/internship/${
                        position.title === 'Software Engineering Intern' ? 'software-engineer' :
                        position.title === 'Marketing Intern' ? 'marketing-intern' :
                        'business-development'
                      }`}
                      className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-[#0049ac] rounded-lg hover:bg-[#0049ac]/90 hover:scale-105 transform transition-all duration-300"
                    >
                      Apply Now
                    </button>
                  </div>
                </div>
                <div>
                  <h5 className="font-medium text-gray-900 mb-2">Requirements:</h5>
                  <ul className="list-disc list-inside text-gray-600 space-y-1">
                    {position.requirements.map((req, idx) => (
                      <li key={idx}>{req}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Application Process - updated styling */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-8">Application Process</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                step: '1',
                title: 'Submit Application',
                description: 'Send your resume and cover letter through our online portal.',
                icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              },
              {
                step: '2',
                title: 'Interview Process',
                description: 'Complete a brief technical assessment and meet with our team.',
                icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              },
              {
                step: '3',
                title: 'Decision & Onboarding',
                description: 'Receive our decision within a week and start your journey with us.',
                icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              }
            ].map((step, index) => (
              <div key={index} className="relative bg-gray-100 p-6 rounded-lg shadow-sm hover:shadow-md transition-all transform hover:scale-105">
                <div className="absolute -top-4 left-6">
                  <div className="rounded-lg bg-[#0049ac] p-3 inline-block">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      {step.icon}
                    </svg>
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className="mt-8 text-xl font-semibold text-gray-900">{step.title}</h4>
                  <p className="mt-4 text-gray-600 leading-relaxed">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}

export default InternshipProgram;